export const getLoginUrl = (env) => {
  switch (env) {
    case "dev":
    case "it":
      return "https://it.login.elavon.com/v1/ui/auth/login/?targetApp=insights";
    case "uat":
      return "https://uat.login.elavon.com/v1/ui/auth/login/?targetApp=insights";
    case "prod":
      return "https://login.elavon.com/v1/ui/auth/login/?targetApp=insights";
    default:
      return "https://login.elavon.com/v1/ui/auth/login/?targetApp=insights";
  }
};
